import gsap from "gsap";

class BulletinsClass {
  constructor() {
    // Сохраняем оригинальный HTML здесь, чтобы не накапливать дубликаты
    this.originalHTML = null;
    // Храним ссылку на анимацию для kill()
    this.animation = null;
  }

  init() {
    const track = document.querySelector(".bulletins__uploads__scan-images");
    const counterEl = document.getElementById("bulletins-uploads-counter");

    if (!track || !counterEl) return;

    // Останавливаем предыдущую анимацию, если она есть
    if (this.animation) {
      this.animation.kill();
    }
    gsap.killTweensOf(track); // Дополнительно убиваем все твины на track

    // Сохраняем оригинальный HTML при первом вызове
    if (!this.originalHTML) {
      this.originalHTML = track.innerHTML;
    }

    // Всегда перестраиваем на основе оригинала (убираем накопление)
    track.innerHTML = this.originalHTML + this.originalHTML;

    const items = Array.from(
      track.querySelectorAll(".bulletins__uploads__scan-image")
    );

    if (items.length === 0) return;

    let count = parseInt(counterEl.textContent.replace(/\D/g, ""), 10) || 0;

    const gap = 20;
    const itemWidth = items[0].offsetWidth + gap;
    // КЛЮЧЕВОЕ ИЗМЕНЕНИЕ: используем оригинальную длину (половина от текущей, т.к. дублировано)
    const originalLength = items.length / 2;
    const totalWidth = itemWidth * originalLength;

    // Сбрасываем позицию для чистого старта
    gsap.set(track, { x: -totalWidth });

    const startX = -totalWidth;
    const normalizedStartX = gsap.utils.wrap(0, totalWidth, -startX);
    let lastItemIndex = Math.floor(normalizedStartX / itemWidth) % originalLength; // Тоже используем originalLength для % 

    const duration = 20;

    // Запускаем новую анимацию и сохраняем ссылку
    this.animation = gsap.to(track, {
      x: 0,
      duration,
      ease: "none",
      repeat: -1,
      modifiers: {
        x: (x) => {
          const current = parseFloat(x);
          return gsap.utils.wrap(-totalWidth, 0, current) + "px";
        },
      },
      onUpdate: () => {
        const currentX = parseFloat(gsap.getProperty(track, "x"));
        const normalizedX = gsap.utils.wrap(0, totalWidth, -currentX);
        const currentItemIndex = Math.floor(normalizedX / itemWidth) % originalLength; // originalLength

        if (currentItemIndex !== lastItemIndex) {
          lastItemIndex = currentItemIndex;
          count++;
          counterEl.textContent = count.toLocaleString("ru-RU");
        }
      },
    });
  }
}

export const bulletins = new BulletinsClass();